const initialState = {
  AssociationsList: [],
  AssociationsListTotal: {
    page: 1,
    size: 10,
    totalCount: 0,
  },

  AssociationDetail: {},
};

export default initialState;
